/**
 * Small semver util — three-part numeric tuple compare. Kept intentionally
 * tiny: no pre-release, no build metadata, no ranges. Matches what the
 * Fincurry app stores in package_info + what admin lets ops save.
 */

const SEMVER_RE = /^\d+\.\d+\.\d+$/;

export function isValidSemver(v: string): boolean {
  return SEMVER_RE.test(v);
}

export function parseSemver(v: string): [number, number, number] {
  const [maj, min, pat] = v.split('.').map((p) => parseInt(p, 10) || 0);
  return [maj, min, pat];
}

/// Returns negative if a < b, positive if a > b, 0 if equal.
export function cmpSemver(a: string, b: string): number {
  const pa = parseSemver(a);
  const pb = parseSemver(b);
  for (let i = 0; i < 3; i++) {
    if (pa[i] !== pb[i]) return pa[i] - pb[i];
  }
  return 0;
}
